module.exports = __webpack_public_path__ + "img/player_turn_002.ee0c90dc.png";